'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { useState, useEffect } from "react";

import CtaWrapper from "@/components/CtaWrapper";
/**
 * @typedef {import("@prismicio/client").Content.SplitContentCtaSlice} SplitContentCtaSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<SplitContentCtaSlice>} SplitContentCtaProps
 * @type {import("react").FC<SplitContentCtaProps>}
 */
const SplitContentCta = ({ slice }) => {
  const { title, description, cta } = slice.primary;

  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageUrl = isDesktop
    ? slice.primary.main_image.url
    : slice.primary.mobile_image.url;
  const imageAlt = isDesktop
    ? slice.primary.main_image_alt || (title?.[0]?.text ?? "")
    : slice.primary.mobile_image_alt || (title?.[0]?.text ?? "");

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-white text-dark-green"
      aria-label={title?.[0]?.text || "Section"}
    >
      <div>
        <div className="flex flex-col md:flex-row">
          <div className={`${slice.variation == 'default' ? 'md:w-3/5 lg:w-[43%]' : 'md:w-3/5 lg:w-[60%]'} flex flex-col gap-11 py-15 framing`}>
            <div className="flex flex-col gap-6">
              {isFilled.richText(title) && (
                <PrismicRichText
                  field={title}
                  components={{
                    heading2: ({ children }) => (
                      <h2 className="h3">{children}</h2>
                    ),
                    heading3: ({ children }) => (
                      <h3 className="h3">{children}</h3>
                    ),
                    heading4: ({ children }) => (
                      <h4 className="h3">{children}</h4>
                    ),
                  }}
                />
              )}
              {isFilled.richText(description) && (
                <PrismicRichText
                  field={description}
                  components={{
                    paragraph: ({ children }) => (
                      <p className="">{children}</p>
                    ),
                  }}
                />
              )}
            </div>
            {Array.isArray(cta) && cta.length > 0 && (
              <CtaWrapper cta={cta} padding={"px-8"} width={`w-full ${cta.length < 2 ? 'w-full md:w-fit' : 'w-full'}`} />
            )}
          </div>
          <div
            className={`${isDesktop ? 'lg:w-[57%]' : 'lg:w-[40%]'} w-full md:h-auto md:w-2/5 h-[300px] bg-no-repeat bg-center bg-cover`}
            style={{ backgroundImage: `url(${imageUrl})` }}
            title={imageAlt}
            role="img"
            aria-label={imageAlt}
          >
            {/* Fallback image pour SEO si JS désactivé */}
            <noscript>
              <img
                src={imageUrl}
                alt={imageAlt}
                style={{ display: "none" }}
              />
            </noscript>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SplitContentCta;
